

































import Component, { mixins } from 'vue-class-component'
import { AgingFilterFormsMixin } from './AgingFilterFormsMixin'
import InputDateRangePicker from '@/components/inputs/InputDateRangePicker.vue'
import moment from 'moment'
import Input from '@/components/inputs/Input.vue'
import Icon from '@/components/Icon.vue'

@Component({
  components: {
    Icon,
    Input,
    InputDateRangePicker
  }
})
export default class BalanceInPeriodFilterForm extends mixins(AgingFilterFormsMixin) {
  localInput: any = ''
  updater: number = 1

  get isDisabled () {
    return !this.dateFrom || !this.dateFrom.isValid() || !this.dateTo || !this.dateTo.isValid()
  }

  get shortcuts () {
    return [
      {
        text: 'Last 7 Days',
        onClick: () => [moment().subtract(7, 'days').toDate(), moment().toDate()]
      },
      {
        text: 'Last 14 Days',
        onClick: () => [moment().subtract(14, 'days').toDate(), moment().toDate()]
      },
      {
        text: 'Month to date',
        onClick: () => [moment().subtract(1, 'months').toDate(), moment().toDate()]
      },
      {
        text: 'Quarter to date',
        onClick: () => [moment().subtract(3, 'months').toDate(), moment().toDate()]
      }
    ]
  }

  get selectedDates (): any {
    return this.filtersMap['period']
  }

  get dateFrom () {
    if (!this.selectedDates || !Object.values(this.selectedDates)) {
      return ''
    }
    const obj: any = Object.values(this.selectedDates)
    return obj[0] && obj[0]['value']
        ? moment(obj[0]['value'][0], 'MM/DD/YYYY')
        : ''
  }

  get dateTo () {
    if (!this.selectedDates || !Object.values(this.selectedDates)) {
      return ''
    }
    const obj: any = Object.values(this.selectedDates)
    return obj[0] && obj[0]['value']
        ? moment(obj[0]['value'][1], 'MM/DD/YYYY')
        : ''
  }

  mounted () {
    const from = moment(this.dateFrom).format('MM/DD/YYYY') !== 'Invalid date'
        ? moment(this.dateFrom).format('MM/DD/YYYY')
        : ''
    const to = moment(this.dateTo).format('MM/DD/YYYY') !== 'Invalid date'
        ? moment(this.dateTo).format('MM/DD/YYYY')
        : ''
    this.localInput = (from + '-' + to) !== '-' ? (from + '-' + to) : ''
  }

  handleInput (event: any) {
    const value = event
    const dateRegExp = '(1[0-2]|0[1-9])/(3[01]|[12][0-9]|0[1-9])/\\d{4}'
    const dateRangeRegExp = new RegExp(`${dateRegExp}-${dateRegExp}`, 'g')
    if (dateRangeRegExp.test(value)) {
      const val = value.split('-')
      this.resetPeriodFilter(val)
    }
  }

  resetPeriodFilter (value: any[]) {
    const filters = { ...this.filtersMap }
    filters['period'] = {}
    this.residentModuleInstance.setCollectionTaskWithAgingFilters(filters)
    const toTEDDateStart = value[0] ? value[0] : ''
    const toTEDDateEnd = value[1] ? value[1] : ''
    const val = `${toTEDDateStart}-${toTEDDateEnd}`
    if (value) {
      const dateInterval: string = `${toTEDDateStart} - ${toTEDDateEnd}`
      this.toggleItem('period', dateInterval, { value: [toTEDDateStart, toTEDDateEnd], label: dateInterval })
    }
    this.localInput = val !== '-' ? val : ''
    this.updater += 1
  }
}
